<template>
  <section class="bg-white py-8">
    
    <div class="container py-8 px-6 mx-auto">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div class="text-left" id="about">
          <h2
            class="uppercase tracking-wide no-underline hover:no-underline font-bold text-gray-800 text-xl mb-8"
          >
            About the project
          </h2>

          <p class="mt-8 mb-8">
            <em>Art burn</em> explore the concept value of art by putting
            artworks up against a monetary value. Burn art to get money. Or,
            keep the art in your collection.
          </p>

          <p class="mt-8 mb-8">
            Each <em>Art burn</em> collection have one or more artworks designed
            to transfer the entire collection balance to it's owner if burned.
            Anyone can transfer ETH to the collection balance through the
            contract deposit method.
          </p>

          <p class="mt-8 mb-8">
            In addition a collection may be dropped with several contribution
            pieces. Sales from contribution pieces will be deposited to the
            collection, hence increasing the value of the pieces that owners can
            burn for ETH.
          </p>
          <p class="mb-3">
            This is a project initiative by Eivind Kleiven. New collections,
            auction times and other announcements will be made on my Twitter
            account, so make sure to follow for updates.
          </p>
          <follow-on-twitter />
        </div>

        <div class="text-left" id="theFirstCollection">
          <h2
            class="uppercase tracking-wide no-underline hover:no-underline font-bold text-gray-800 text-xl mb-8"
          >
            The first collection
          </h2>
          The first <em>Art burn</em> collection is <em class="font-semibold">The first collection</em>.
          The collection has two artworks that will transfer collection balance to it's owner if burned and 16 open edition contribution pieces.
        
        <div class="text-gray-500 text-xl text-center italic py-8" v-if="hasProvider">
          The current collection balance is Ξ {{ web3Dapp.utils.fromWei(collectionBalance, "ether") }}
        </div>


          <h3
            class="tracking-wide no-underline hover:no-underline font-bold text-gray-800 text-lg mt-8"
          >Background</h3>

          <p class="mt-8 mb-8">
            With the Art burn project I continue to explore the concept value of art by use 
            of art and this time I use Blockchain.
            Therefore I decided to let <em class="font-semibold">The first collection</em> 
            be digital versions of my physical art project from 2018;
            <a
              class="text-gray-800 underline hover:text-gray-900"
              href="https://valueof.art"
              >Value of art</a
            >.
            </p>

            <p class="mt-8 mb-8">
            To give some background I will write a little bit about the physical art project first:
            It consist of two pieces <em>FUD Block 514848</em> and
            <em>FOMO Block 514848</em>. Each piece is a 5x5 cm tungsten cube, having same weight as gold,
            engraved with every transaction hash of BTC block 514848. At any
            time, the owner of either one of the two sculptures can choose to
            destroy his or her's sculpture and be rewarded with 0.6454 BTC
            (approximately 22 000 USD). At the same time, the exact same amount
            would disappear from the other owner’s sculpture. That is, one owner
            loses the sculpture value as an art piece, but receive a monetary
            value. The other owner loses a monetary value, but keep his or her
            piece of art, which will be the only left of the two.
          </p>
          <h3 class="tracking-wide no-underline hover:no-underline font-bold text-gray-800 text-lg mt-8">
            The NFT's
          </h3>

          <p class="mt-8 mb-8">
            <em class="font-semibold">The first collection</em> have the
            following two main artworks
            <em>FUD Block 514848</em> and
            <em>FOMO Block 514848</em>. If either of
            them is burned, the entire collection balance will be transfered to
            it's owner. They will be sold on auction on  <a
              class="text-gray-800 underline hover:text-gray-900"
              href="https://opensea.io"
              >opensea.io</a
            >.
          </p>
          <p class="mt-8 mb-8">
            For each main piece, there are 8 contribution
            pieces. They are sold as open edition limited by their increasing price.
            Each time a contribution piece is sold the price increase by 10 percent for 
            that piece. 
            Meaning, low edition numbers will be cheaper than higher edition numbers.
            
            If the first edition number of a contribution piece is burned, then no more of that contribution piece can be minted.
            
            ETH from Contribution piece sales is deposited to the collection balance by the contract and can hence be 
            withdrawn by burning either <em>FUD Block 514848</em> or <em>FOMO Block 514848</em>.
          </p>

          <p class="mt-8 mb-8">
            Each piece in <em>The First Collection</em>, including the contribution
            pieces, is an interactive 3D cube with infinite resolution that can
            be displayed on any modern browser without the need of any third
            party libraries or installs. Show it on your Samsung TV browser, no
            apps needed and it will fill your entire screen no matter screen
            dimensions. Of course they are ERC721 tokens and compatible with
            <a
              class="text-gray-800 underline hover:text-gray-900"
              href="https://opensea.io/"
              >opensea.io</a
            >.
            However, on opensea you will see an animation of the piece instead
            of the interactive piece. The external content link will take you to
            the interactive piece.
          </p>
           <p class="mt-8 mb-8">
            The background video of the two main pieces are NASA footage of the sun.
            The background image of the contribution pieces are NASA footage of a black hole.
<small>(This project has no affiliation with NASA)</small>.
            
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import FollowOnTwitter from "./FollowOnTwitter.vue";

export default {
  name: "About",
  props: {
    collectionBalance: {
      type: String,
      required: true,
    },
  },
  components: {
    FollowOnTwitter,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
